import * as React from 'react'
import ErrorPage from 'components/error-page'
export default class ShortlinkNotFound extends React.Component<any> {
  render(): React.ReactElement<'div'> {
    return (
      <div>
        <ErrorPage
          title="This link doesn't work."
          description={
            <span>
              Please contact the person who sent you this list for another link.
            </span>
          }
        />
      </div>
    )
  }
}
